/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Byte4Word200Response,
    Byte4Word200ResponseFromJSON,
    Byte4Word200ResponseToJSON,
    DeadLink200Response,
    DeadLink200ResponseFromJSON,
    DeadLink200ResponseToJSON,
    WarningWord200Response,
    WarningWord200ResponseFromJSON,
    WarningWord200ResponseToJSON,
    YahooProofResponse,
    YahooProofResponseFromJSON,
    YahooProofResponseToJSON,
} from '../models';

export interface CallByte4WordApiRequest {
    title: string;
    subtitle: string;
    head: string;
    sentence: string;
}

export interface CallDeadLinkApiRequest {
    title: string;
    subtitle: string;
    head: string;
    sentence: string;
}

export interface CallWarningWordApiRequest {
    title: string;
    subtitle: string;
    head: string;
    sentence: string;
}

export interface CallYahooProofApiRequest {
    sentence: string;
    noFilter: string;
    devId: string;
    id: number;
}

/**
 * 
 */
export class ProofreadingApi extends runtime.BaseAPI {

    /**
     * 文字化けする可能性のある文字を検出する API
     */
    async callByte4WordApiRaw(requestParameters: CallByte4WordApiRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Byte4Word200Response>> {
        if (requestParameters.title === null || requestParameters.title === undefined) {
            throw new runtime.RequiredError('title','Required parameter requestParameters.title was null or undefined when calling callByte4WordApi.');
        }

        if (requestParameters.subtitle === null || requestParameters.subtitle === undefined) {
            throw new runtime.RequiredError('subtitle','Required parameter requestParameters.subtitle was null or undefined when calling callByte4WordApi.');
        }

        if (requestParameters.head === null || requestParameters.head === undefined) {
            throw new runtime.RequiredError('head','Required parameter requestParameters.head was null or undefined when calling callByte4WordApi.');
        }

        if (requestParameters.sentence === null || requestParameters.sentence === undefined) {
            throw new runtime.RequiredError('sentence','Required parameter requestParameters.sentence was null or undefined when calling callByte4WordApi.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.title !== undefined) {
            formParams.append('title', requestParameters.title as any);
        }

        if (requestParameters.subtitle !== undefined) {
            formParams.append('subtitle', requestParameters.subtitle as any);
        }

        if (requestParameters.head !== undefined) {
            formParams.append('head', requestParameters.head as any);
        }

        if (requestParameters.sentence !== undefined) {
            formParams.append('sentence', requestParameters.sentence as any);
        }

        const response = await this.request({
            path: `/my_c3/api/byte4_word_api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Byte4Word200ResponseFromJSON(jsonValue));
    }

    /**
     * 文字化けする可能性のある文字を検出する API
     */
    async callByte4WordApi(requestParameters: CallByte4WordApiRequest, initOverrides?: RequestInit): Promise<Byte4Word200Response> {
        const response = await this.callByte4WordApiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * リンク切れの可能性がある URL を検出する API
     */
    async callDeadLinkApiRaw(requestParameters: CallDeadLinkApiRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeadLink200Response>> {
        if (requestParameters.title === null || requestParameters.title === undefined) {
            throw new runtime.RequiredError('title','Required parameter requestParameters.title was null or undefined when calling callDeadLinkApi.');
        }

        if (requestParameters.subtitle === null || requestParameters.subtitle === undefined) {
            throw new runtime.RequiredError('subtitle','Required parameter requestParameters.subtitle was null or undefined when calling callDeadLinkApi.');
        }

        if (requestParameters.head === null || requestParameters.head === undefined) {
            throw new runtime.RequiredError('head','Required parameter requestParameters.head was null or undefined when calling callDeadLinkApi.');
        }

        if (requestParameters.sentence === null || requestParameters.sentence === undefined) {
            throw new runtime.RequiredError('sentence','Required parameter requestParameters.sentence was null or undefined when calling callDeadLinkApi.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.title !== undefined) {
            formParams.append('title', requestParameters.title as any);
        }

        if (requestParameters.subtitle !== undefined) {
            formParams.append('subtitle', requestParameters.subtitle as any);
        }

        if (requestParameters.head !== undefined) {
            formParams.append('head', requestParameters.head as any);
        }

        if (requestParameters.sentence !== undefined) {
            formParams.append('sentence', requestParameters.sentence as any);
        }

        const response = await this.request({
            path: `/my_c3/api/dead_link_api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeadLink200ResponseFromJSON(jsonValue));
    }

    /**
     * リンク切れの可能性がある URL を検出する API
     */
    async callDeadLinkApi(requestParameters: CallDeadLinkApiRequest, initOverrides?: RequestInit): Promise<DeadLink200Response> {
        const response = await this.callDeadLinkApiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 取り下げの可能性のある単語を検出する API
     */
    async callWarningWordApiRaw(requestParameters: CallWarningWordApiRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<WarningWord200Response>> {
        if (requestParameters.title === null || requestParameters.title === undefined) {
            throw new runtime.RequiredError('title','Required parameter requestParameters.title was null or undefined when calling callWarningWordApi.');
        }

        if (requestParameters.subtitle === null || requestParameters.subtitle === undefined) {
            throw new runtime.RequiredError('subtitle','Required parameter requestParameters.subtitle was null or undefined when calling callWarningWordApi.');
        }

        if (requestParameters.head === null || requestParameters.head === undefined) {
            throw new runtime.RequiredError('head','Required parameter requestParameters.head was null or undefined when calling callWarningWordApi.');
        }

        if (requestParameters.sentence === null || requestParameters.sentence === undefined) {
            throw new runtime.RequiredError('sentence','Required parameter requestParameters.sentence was null or undefined when calling callWarningWordApi.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.title !== undefined) {
            formParams.append('title', requestParameters.title as any);
        }

        if (requestParameters.subtitle !== undefined) {
            formParams.append('subtitle', requestParameters.subtitle as any);
        }

        if (requestParameters.head !== undefined) {
            formParams.append('head', requestParameters.head as any);
        }

        if (requestParameters.sentence !== undefined) {
            formParams.append('sentence', requestParameters.sentence as any);
        }

        const response = await this.request({
            path: `/my_c3/api/warning_word_api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarningWord200ResponseFromJSON(jsonValue));
    }

    /**
     * 取り下げの可能性のある単語を検出する API
     */
    async callWarningWordApi(requestParameters: CallWarningWordApiRequest, initOverrides?: RequestInit): Promise<WarningWord200Response> {
        const response = await this.callWarningWordApiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Yahoo の校正支援 API で校正を行う API
     */
    async callYahooProofApiRaw(requestParameters: CallYahooProofApiRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<YahooProofResponse>> {
        if (requestParameters.sentence === null || requestParameters.sentence === undefined) {
            throw new runtime.RequiredError('sentence','Required parameter requestParameters.sentence was null or undefined when calling callYahooProofApi.');
        }

        if (requestParameters.noFilter === null || requestParameters.noFilter === undefined) {
            throw new runtime.RequiredError('noFilter','Required parameter requestParameters.noFilter was null or undefined when calling callYahooProofApi.');
        }

        if (requestParameters.devId === null || requestParameters.devId === undefined) {
            throw new runtime.RequiredError('devId','Required parameter requestParameters.devId was null or undefined when calling callYahooProofApi.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling callYahooProofApi.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.sentence !== undefined) {
            formParams.append('sentence', requestParameters.sentence as any);
        }

        if (requestParameters.noFilter !== undefined) {
            formParams.append('no_filter', requestParameters.noFilter as any);
        }

        if (requestParameters.devId !== undefined) {
            formParams.append('dev_id', requestParameters.devId as any);
        }

        if (requestParameters.id !== undefined) {
            formParams.append('id', requestParameters.id as any);
        }

        const response = await this.request({
            path: `/my_c3/api/yahoo_proof_api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YahooProofResponseFromJSON(jsonValue));
    }

    /**
     * Yahoo の校正支援 API で校正を行う API
     */
    async callYahooProofApi(requestParameters: CallYahooProofApiRequest, initOverrides?: RequestInit): Promise<YahooProofResponse> {
        const response = await this.callYahooProofApiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
